const GET_ENROLLMENT_HISTORY: string = 'GET_ENROLLMENT_HISTORY';
const GET_ENROLLMENT_HISTORY_ERROR: string = 'GET_ENROLLMENT_HISTORY_ERROR';
const GET_HISTORICAL_ENROLLMENTS: string = 'GET_HISTORICAL_ENROLLMENTS';
const GET_HISTORICAL_ENROLLMENTS_ERROR: string = 'GET_HISTORICAL_ENROLLMENTS_ERROR';

export const ENROLLMENT_HISTORY_ACTION_TYPES = {
    GET_ENROLLMENT_HISTORY,
    GET_ENROLLMENT_HISTORY_ERROR,
    GET_HISTORICAL_ENROLLMENTS,
    GET_HISTORICAL_ENROLLMENTS_ERROR
};